import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import PivotalFormApi from "../../../js/csf/pivotal/PivotalFormApi";
import PivotalSearchApi from "../../../js/csf/pivotal/PivotalSearchApi";
import { createRoot } from "react-dom/client";
import DrupalAccessTokenApi from "../../../js/csf/DrupalAccessTokenApi";

export function CsfPivotalFournisseurCompanyProfile({ apiUrl, apiEnv }) {

  const [accessToken, setAccessToken] = useState('');
  const [company, setCompany] = useState([]);
  const [contact, setContact] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [companyId, setCompanyId] = useState('');
  const langcode = document.documentElement.lang;

  /*
  * On components mounts add an event on the company profile modal item and fetch the token.
  * */
  useEffect(() => {
    fetchAccessToken();
    addEventOnCompanyProfilMenuItem();
  }, []);

  /*
  * fetch the connected person detail.
  * */
  useEffect(() => {
    if (openModal === true && accessToken !== '') {
      getConnectedUserInfo();
    }
  }, [openModal]);

  /*
  * fetch the company profil if modal is attempted to be open.
  * */
  useEffect(() => {
    if (companyId !== '') {
      getCompanyProfileInfo();
    }
  }, [companyId]);

  /*
  * add event on the company profil link in the menu.
  * */
  function addEventOnCompanyProfilMenuItem() {
    const link = document.querySelector('.company-profil-open-modal');
    if (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        setOpenModal(true);
        $('#companyProfilModal').modal();
      });
    }
  }

  /*
  * Method to call drupal api to get the access token of the session.
  * */
  function fetchAccessToken() {
    const drupalAccessTokenApi = new DrupalAccessTokenApi();
    drupalAccessTokenApi.fetchPostRequest('fournisseur')
      .then(response => {
        if (response?.api_access_token) {
          setAccessToken(response.api_access_token);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }


  /*
  * Method that handle the recuperation of the company IF of the connected user.
  * */
  function getConnectedUserInfo() {
    const requestData = {
      search: 'Current_Ux_Client_User',
      searchResultsList: 'CSF_EP_UXSupplier_Profile_SRL'
    };
    const pivotalSearchApi = new PivotalSearchApi(apiUrl, apiEnv, accessToken);
    pivotalSearchApi.callSearchEndpoint(requestData, '_Espace_Partenaire')
      .then(response => {
        if (response?.success && response?.payload?.data?.rows?.length >= 0) {
          setCompanyId(response.payload.data.rows[0].Primary_Company);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  /*
  * Method that handle the recuperation of the company full info.
  * */
  function getCompanyProfileInfo() {
    const requestData = {
      form: 'CSF_EP_UXCompany_REST',
      recordId: companyId
    };
    const pivotalFormApi = new PivotalFormApi(apiUrl, apiEnv, accessToken);
    pivotalFormApi.callFormRecuperationEndpoint(requestData, '_Espace_Partenaire')
      .then(response => {
        if (response?.success && response?.payload?.data?.primary) {
          setCompany(response.payload.data.primary);
        }
        if (response?.success && response?.payload?.data?.primary?.Contact__Secondary && response?.payload?.data?.primary?.Contact__Secondary.length > 0) {
          setContact(response.payload.data.primary.Contact__Secondary[0]);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  return (
    <div className="modal fade" id="companyProfilModal" tabIndex="-1" role="dialog" aria-labelledby="companyProfilModalTitle"
      aria-hidden="true">
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h2 id="companyProfilModalTitle">{window.Drupal.t('fournisseur.company.profil.modal.title')}</h2>
            <button type="button" className="close" data-dismiss="modal" aria-label={window.Drupal.t('lang.modal.close')}>
              <i className="icon icon-csf-close-noborder"><span className="d-none">&nbsp;</span></i>
            </button>
          </div>

          <div className="modal-body">
            <div className="main-info">
              <h3 className="heading">{company.Company_Id__Rn_Descriptor}</h3>
              <p className="description">
                {(company.EP_Company_Description_FR && langcode === 'fr') && (
                  company.EP_Company_Description_FR
                )}
                {(company.EP_Company_Description_EN && langcode === 'en') && (
                  company.EP_Company_Description_EN
                )}
              </p>
              <div className="prereq-content" style={{ paddingTop: "1rem" }}>
                <div dangerouslySetInnerHTML={{ __html: window.Drupal.t('fournisseur.company.profil.modal.warning.details') }}></div>
              </div>
              <div className="row">
                <div className="col-12 col-xl-4">
                  <div className="form-group">
                    <label htmlFor="Name">{window.Drupal.t('fournisseur.company.profil.modal.contact.label')}</label>
                    <input disabled value={(contact.First_Name || '') + ' ' + (contact.Last_Name || '')}
                      required type="text" id="Name" name="Name" />
                  </div>
                </div>
                <div className="col-12 col-xl-4">
                  <div className="form-group">
                    <label htmlFor="Email">{window.Drupal.t('fournisseur.gestion.table.email')}</label>
                    <input disabled value={contact.RREG_Corres_Email_Id__Rn_Descriptor || ''}
                      required type="text" id="Email" name="Email" />
                  </div>
                </div>
                <div className="col-12 col-xl-4">
                  <div className="form-group">
                    <label
                      htmlFor="Phone">{window.Drupal.t('fournisseur.company.profil.modal.phone.label')}</label>
                    <input disabled value={contact.Phone || ''}
                      required type="text" id="Phone" name="Phone" />
                  </div>
                </div>
              </div>
            </div>

            <div className="company-info inner-wrapper">
              <h4>{window.Drupal.t('fournisseur.company.profil.modal.company_section.title')}</h4>
              <fieldset>
                <legend className="sr-only">{window.Drupal.t('fournisseur.company.profil.modal.adresse.full')}</legend>
                <div className="row">
                  <div className="col-12 col-xl-6">
                    <div className="form-group">
                      <label
                        htmlFor="Adresse">{window.Drupal.t('fournisseur.company.profil.modal.adresse.label')}</label>
                      <input disabled value={company.Company_Address_1 || ''}
                        required type="text" id="Adresse" name="Adresse" />
                    </div>
                  </div>
                  <div className="col-12 col-xl-6">
                    <div className="form-group">
                      <label htmlFor="Postal">{window.Drupal.t('fournisseur.company.profil.modal.postal.label')}</label>
                      <input disabled value={company.Company_Zip || ''}
                        required type="text" id="Postal" name="Postal" />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 col-xl-6">
                    <div className="form-group">
                      <label htmlFor="Ville">{window.Drupal.t('fournisseur.company.profil.modal.city.label')}</label>
                      <input disabled value={company.Company_City || ''}
                        required type="text" id="Ville" name="Ville" />
                    </div>
                  </div>
                  <div className="col-12 col-xl-6">
                    <div className="form-group">
                      <label
                        htmlFor="Province">{window.Drupal.t('fournisseur.company.profil.modal.province.label')}</label>
                      <input disabled value={company.Company_State || ''}
                        required type="text" id="Province" name="Province" />
                    </div>
                  </div>
                </div>
              </fieldset>

              <fieldset>
                <legend className="sr-only">
                  {window.Drupal.t('fournisseur.company.profil.modal.phone_company.label')} - {window.Drupal.t('fournisseur.company.profil.modal.poste.label')}
                </legend>
                <div className="row">
                  <div className="col-12 col-xl-9">
                    <div className="form-group">
                      <label
                        htmlFor="Phone_Company">{window.Drupal.t('fournisseur.company.profil.modal.phone_company.label')}</label>
                      <input disabled value={company.Company_Phone || ''}
                        required type="text" id="Phone_Company" name="Phone_Company" />
                    </div>
                  </div>
                  <div className="col-12 col-xl-3">
                    <div className="form-group">
                      <label htmlFor="Poste">{window.Drupal.t('fournisseur.company.profil.modal.poste.label')}</label>
                      <input disabled value={company.Company_Phone_Ext || ''}
                        required type="text" id="Poste" name="Poste" />
                    </div>
                  </div>
                </div>
              </fieldset>

              <div className="row">
                <div className="col-12 col-xl-12">
                  <div className="form-group">
                    <label
                      htmlFor="Email_Company">{window.Drupal.t('fournisseur.company.profil.modal.email.label')}</label>
                    <input disabled value={company.Alt_Email_Id__Rn_Descriptor || ''}
                      required type="text" id="Email_Company" name="Email_Company" />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-12 col-xl-12">
                  <div className="form-group">
                    <label
                      htmlFor="Site_Web">{window.Drupal.t('fournisseur.company.profil.modal.webiste.label')}</label>
                    <input disabled value={company.WWW || ''}
                      required type="text" id="Site_Web" name="Site_Web" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-footer justify-content-center">
            <button type="button" className="button btn-outlined btn-larger"
              data-dismiss="modal">{window.Drupal.t('fournisseur.back.btn')}</button>
          </div>
        </div>
      </div>
    </div>
  );
}

window.addEventListener('DOMContentLoaded', () => {
  const domNode = document.getElementById('CsfPivotalFournisseurCompanyProfile');

  if (domNode !== null) {
    const root = createRoot(domNode);

    const apiUrl = domNode.getAttribute("data-api-url");
    const apiEnv = domNode.getAttribute("data-api-env");


    root.render(<CsfPivotalFournisseurCompanyProfile
      apiUrl={apiUrl}
      apiEnv={apiEnv}
    />);
  }
});

CsfPivotalFournisseurCompanyProfile.propTypes = {
  apiUrl: PropTypes.string,
  apiEnv: PropTypes.string,
};
